import React from 'react';
import { node } from 'prop-types';
import {
  MobileFirstResponsiveLayout, MobileRow, REST_OF_LINE, FULL_WIDTH, FULL_WIDTH_ALIGN_RIGHT
} from '../genericComponents/MobileFirstResponsiveLayout/MobileFirstResponsiveLayout';
import './packagePodFulfillmentAndActionsLayout.scss';

export const FulfillmentAndActionsLayout = ({
  FulfillmentMessage, ProductDetailsButton, Quantity, QuantityError, Remove, SwapItem
}) => (
  <MobileFirstResponsiveLayout>
    <MobileRow
      desktop={{
        growth: REST_OF_LINE,
        cssOrder: -1
      }}
    >
      <div className="package-pod-fulfillment-and-actions-layout__fulfillment-message">
        {FulfillmentMessage}
      </div>
    </MobileRow>
    <MobileRow desktop={{ cssOrder: 1 }}>
      {ProductDetailsButton}
    </MobileRow>
    {(SwapItem || Quantity) && (
      <MobileRow desktop={{ cssOrder: 1 }}>
        <div className="package-pod-fulfillment-and-actions-layout__swap-quantity-wrapper">
          {SwapItem && (
            <div className="package-pod-fulfillment-and-actions-layout__swap">
              {SwapItem}
            </div>
          )}
          {Quantity && (
            <div className="package-pod-fulfillment-and-actions-layout__quantity">
              {Quantity}
            </div>
          )}
        </div>
      </MobileRow>
    )}
    {
      Quantity && QuantityError && (
        <MobileRow desktop={{ cssOrder: 1, growth: FULL_WIDTH, fullWidthAlign: FULL_WIDTH_ALIGN_RIGHT }}>
          <div className="package-pod-fulfillment-and-actions-layout__quantity-error">
            {QuantityError}
          </div>
        </MobileRow>
      )
    }
    {
      Remove && (
        <MobileRow>
          <div className="package-pod-fulfillment-and-actions-layout__remove">

            {Remove}
          </div>
        </MobileRow>
      )
    }
  </MobileFirstResponsiveLayout>
);

FulfillmentAndActionsLayout.propTypes = {
  FulfillmentMessage: node,
  ProductDetailsButton: node.isRequired,
  Quantity: node.isRequired,
  QuantityError: node,
  Remove: node.isRequired,
  SwapItem: node.isRequired
};

FulfillmentAndActionsLayout.defaultProps = {
  FulfillmentMessage: null,
  QuantityError: null,
};
